import isArrayLike from './is-array-like';
export default (function (value) {
  return isArrayLike(value) ? Array.prototype.slice.call(value) : [];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/to-array.js
// module id = 111
// module chunks = 0